import React from "react";
import { Link, useLocation } from "react-router-dom";

function Navigation() {
  const loca = useLocation();
  const navigationRoutes = [
    "/privacy-policy",
    "/terms-and-conditions",
    "/support",
    "/about",
  ];
  
  if (navigationRoutes.includes(loca.pathname)) return null;

  return (
    <nav>
      <ul>
        <li>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </li>
        <li>
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
        </li>
        <li>
          <Link to="/support">Support</Link>
        </li>
        <li>
          <Link to="/about">About Us</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;
